import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { SiaTranslatePipe } from '../../pipes/sia-translate.pipe';
import { RuntimePwaApp } from '../../services/runtime-config';

export interface SiaPwaInstallInstructionsDialogData {
  app: RuntimePwaApp;
  mode: 'ios' | 'generic' | 'timeout';
}

@Component({
  selector: 'sia-pwa-install-instructions-dialog',
  templateUrl: './sia-pwa-install-instructions-dialog.component.html',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIcon, SiaTranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiaPwaInstallInstructionsDialogComponent {
  data = inject<SiaPwaInstallInstructionsDialogData>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<SiaPwaInstallInstructionsDialogComponent>);

  app = computed(() => this.data.app);
  mode = computed(() => this.data.mode);

  close() {
    this.dialogRef.close();
  }
}
